import React, { memo } from 'react';
import { Icon } from 'hoi-poi-ui';

const RowDetailWidgetContent = memo(({ icon, iconName, value }) => {
    return (
        <div className="widget-detail-row__value__with-icon">
            {icon && value && <div className="widget-detail-row__value__icon">{icon}</div>}
            {iconName && value && (
                <div className="widget-detail-row__value__icon">
                    <Icon name={iconName} />
                </div>
            )}

            <div className="widget-detail-row__value__content">{value || '-'}</div>
        </div>
    );
});

export default RowDetailWidgetContent;
